export default __webpack_public_path__ + "static/media/imagePickAndPackContentEight.6d1376a4.png";